/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurveyListItemDto } from './SurveyListItemDto';
import {
    SurveyListItemDtoFromJSON,
    SurveyListItemDtoFromJSONTyped,
    SurveyListItemDtoToJSON,
    SurveyListItemDtoToJSONTyped,
} from './SurveyListItemDto';

/**
 * 
 * @export
 * @interface SurveyListResponseDto
 */
export interface SurveyListResponseDto {
    /**
     * 
     * @type {Array<SurveyListItemDto>}
     * @memberof SurveyListResponseDto
     */
    items?: Array<SurveyListItemDto>;
    /**
     * Total number of surveys
     * @type {number}
     * @memberof SurveyListResponseDto
     */
    totalCount?: number;
    /**
     * Indicates if there are more pages available
     * @type {boolean}
     * @memberof SurveyListResponseDto
     */
    hasNextPage?: boolean;
}

/**
 * Check if a given object implements the SurveyListResponseDto interface.
 */
export function instanceOfSurveyListResponseDto(value: object): value is SurveyListResponseDto {
    return true;
}

export function SurveyListResponseDtoFromJSON(json: any): SurveyListResponseDto {
    return SurveyListResponseDtoFromJSONTyped(json, false);
}

export function SurveyListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SurveyListItemDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
    };
}

export function SurveyListResponseDtoToJSON(json: any): SurveyListResponseDto {
    return SurveyListResponseDtoToJSONTyped(json, false);
}

export function SurveyListResponseDtoToJSONTyped(value?: SurveyListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SurveyListItemDtoToJSON)),
        'totalCount': value['totalCount'],
        'hasNextPage': value['hasNextPage'],
    };
}

